module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_48.ea9e4269.jpg";